<template>
  <div v-if="loading && !['currentMessage'].includes($route.name)" :class="{ transparent: loading }">
    <b-spinner
      style="width: 4rem; height: 4rem;"
      variant="info"
      class="circle"
    ></b-spinner>

    <div v-if="loadingMessage"
     class="loader-message"><strong>{{ loadingMessage }}</strong></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Loader',
  computed: {
    ...mapGetters({
      loading: 'fetchLoading',
      loadingMessage: 'loadingMessage',
    }),
  },
};
</script>

<style scoped>
.loader-message {
  position: fixed;
  top: 63%;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);
  text-align: center;
}
.transparent {
  background: rgba(255, 255, 255, 0.4) !important;
  position: fixed;
  z-index: 100000;
  width: 100%;
  height: 100%;
}
.circle {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10;
}
</style>
